var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListBuilder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 17.8878H5.5V16.6378H1.75V1.63779H11.75V7.88779H13V1.63779C13 0.950287 12.4375 0.387787 11.75 0.387787H1.75C1.0625 0.387787 0.5 0.950287 0.5 1.63779V16.6378C0.5 17.3253 1.0625 17.8878 1.75 17.8878ZM14.6938 9.31897L16.5688 11.194C16.8126 11.4377 16.8126 11.8315 16.5688 12.0752L10.7626 17.8815H8.00631V15.1252L13.8126 9.31897C14.0563 9.07522 14.4501 9.07522 14.6938 9.31897ZM9.25006 16.6377H10.2438L13.3688 13.5127L12.3751 12.519L9.25006 15.644V16.6377ZM13.2563 11.6377L14.2501 12.6315L15.2438 11.6377L14.2501 10.644L13.2563 11.6377ZM8.625 8.51279H4.875C3.8375 8.51279 3 9.35029 3 10.3878V11.0128H4.25V10.3878C4.25 10.044 4.53125 9.76279 4.875 9.76279H8.625C8.96875 9.76279 9.25 10.044 9.25 10.3878V11.0128H10.5V10.3878C10.5 9.35029 9.6625 8.51279 8.625 8.51279ZM9.25 5.38779C9.25 6.76904 8.13125 7.88779 6.75 7.88779C5.36875 7.88779 4.25 6.76904 4.25 5.38779C4.25 4.00654 5.36875 2.88779 6.75 2.88779C8.13125 2.88779 9.25 4.00654 9.25 5.38779ZM8 5.38779C8 4.70029 7.4375 4.13779 6.75 4.13779C6.0625 4.13779 5.5 4.70029 5.5 5.38779C5.5 6.07529 6.0625 6.63779 6.75 6.63779C7.4375 6.63779 8 6.07529 8 5.38779Z",
    fill: "url(#paint0_linear_109_643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_643",
    x1: 0.5,
    y1: 0.689606,
    x2: 17.1667,
    y2: 18.1896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59E0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBuilder);
export default __webpack_public_path__ + "static/media/list-builder.7f740779719fa1368cee035bd481c5b6.svg";
export { ForwardRef as ReactComponent };